































import { Event } from '@ssp/inscreva-sse-models';
import { Component, Vue, Prop } from 'vue-property-decorator';

import EventInfoDatesComponent from './EventInfoDates.vue';
import EventInfoPlace from './EventInfoPlace.vue';
import LocationMap from './LocationMap.vue';

@Component({
  components: {
    LocationMap,
    EventInfoPlace,
    EventInfoDates: EventInfoDatesComponent,
  },
})
export default class EventPresentationComponent extends Vue {
  @Prop({ required: true, type: Event })
  private event!: Event;
}
